import { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';

import {
  Autocomplete,
  Box,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
  TextField,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Modal,
  InputLabel,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  Stack,
  Snackbar,
  Paper
} from "@mui/material";
import MuiAlert from '@mui/material/Alert';

import axios from  "axios";
import { Formik } from 'formik';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';

import PhoneInput from 'react-phone-input-2';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '80%', md: 400 },
  maxHeight: '66vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflow: 'scroll'
};

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Subdb = () => {
    const [value, setValue] = useState(0);
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const [data, setData] = useState({});
    const [agenData, setAgenData] = useState([]);
    const [resellerData, setResellerData] = useState([]);
    const [marketerData, setMarketerData] = useState([]);
    const [tabIndex, setTabIndex] = useState({});

    const [openDelDialog, setOpenDelDialog] = useState(false);
    const [entityToDelete, setEntityToDelete] = useState([]);

    const handleDeleteDialog = (id, entity) => {
      setOpenDelDialog(true);
      setEntityToDelete([id, entity]);
    };

    const handleCloseDeleteDialog = () => {
      setOpenDelDialog(false);
      setEntityToDelete([]);
    };

    const handleDelete = async (id, entity) => {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/dashboard/subdb/${entity}/${id}`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
        }
      });
      const getData = async () => {
        try {
          const agen = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/subdb/list`, {
            headers: {
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            }
          });

          let mappedObj = {};
          let tabIndexObj = {};
          let index = -1;

          Object.keys(agen.data.result).forEach((v,i) => {
            index+=1;
            let number = 0;
            mappedObj[v] = agen.data.result[v].map((item) => {
              number+=1;
              return { ...item, no: number };    
            })
            tabIndexObj[v] = index;
          });
          setData(mappedObj);
          // setTabIndex(tabIndexObj);

        } catch (err) {
          console.log(err);
        }
      };
      getData();
      // if( entity === 'agen' ) {
      //   const agen = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/subdb/agen`, {
      //     headers: {
      //       Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
      //     }
      //   });
      //   let number = 0;
      //   setAgenData(agen.data.result.map((v) => {
      //     number+=1;
      //     return { ...v, no: number };
      //   }));
      // }
      // if( entity === 'reseller' ) {
      //   const agen = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/subdb/reseller`, {
      //     headers: {
      //       Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
      //     }
      //   });
      //   let number = 0;
      //   setResellerData(agen.data.result.map((v) => {
      //     number+=1;
      //     return { ...v, no: number };
      //   }));
      // }
      // if( entity === 'marketer' ) {
      //   const agen = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/subdb/marketer`, {
      //     headers: {
      //       Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
      //     }
      //   });
      //   let number = 0;
      //   setMarketerData(agen.data.result.map((v) => {
      //     number+=1;
      //     return { ...v, no: number };
      //   }));
      // }
      setAlertStatus('success');
      setAlertMessage('Delete berhasil')
      setOpenAlert(true);
      handleCloseDeleteDialog();
    };

    const [openAlert, setOpenAlert] = useState(false);
    const [alertStatus, setAlertStatus] = useState('success');
    const [alertMessage, setAlertMessage] = useState('');
    const handleClickAlert = () => {
        setOpenAlert(true);
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const [wa, setWa] = useState(null);
    const changeWa = (value) =>  {
      setWa(value);
    };

    const [subdistricts, setSubdistricts] = useState([]);
    const [valueSubdistrict, setValueSubdistrict] = useState(null);
    const handleSelectSubdistrict = (e, val) => {
        setValueSubdistrict(val);
    };
    

    const [cities, setCities] = useState([]);
    const [valueCity, setValueCity] = useState(null);
    const handleSelectCity = async (e, val) => {
        setValueCity(val);
        try {
            const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/subdistrict/${val.city_id}`);
            setSubdistricts(getData.data.result);
        } catch (err) {
            console.log(err);
        }
    };

    const [provinces, setProvinces] = useState([]);
    const [valueProvince, setValueProvince] = useState(null);
    const [inputProvValue, setInputProvValue] = useState('');
    const handleSelectProvince = async (e, val) => {
        setValueProvince(val);
        try {
            const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/city/${val.province_id}`);
            setCities(getData.data.result);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
      const getData = async () => {
        try {
          const agen = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/subdb/list`, {
            headers: {
              Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            }
          });

          let mappedObj = {};
          let tabIndexObj = {};
          let index = -1;

          Object.keys(agen.data.result).forEach((v,i) => {
            index+=1;
            let number = 0;
            mappedObj[v] = agen.data.result[v].map((item) => {
              number+=1;
              return { ...item, no: number };    
            })
            tabIndexObj[v] = index;
          });
          setData(mappedObj);
          setTabIndex(tabIndexObj);

        } catch (err) {
          console.log(err);
        }
      };
      const getProvinces = async () => {
        try {
          const getData = await axios.get(`${process.env.REACT_APP_API_URL}/api/region/province`);
          setProvinces(getData.data.result);
        } catch (err) {
          console.log(err);
        }
      }
      getProvinces();
      getData();
    }, [])

    return (
        <div style={{ minHeight: '80vh'}}>
          <Snackbar
            open={openAlert}
            autoHideDuration={2500}
            onClose={handleCloseAlert}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            key={'top' + 'center'}
          >
            <Alert onClose={handleCloseAlert} severity={alertStatus} sx={{ width: '100%' }}>
                {alertMessage}
            </Alert>
          </Snackbar>
          <Dialog
            open={openDelDialog}
            onClose={handleCloseDeleteDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Apakah anda akan menghapus mitra ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDeleteDialog}>Batal</Button>
              <Button onClick={() => handleDelete(entityToDelete[0], entityToDelete[1])}>
                Ya
              </Button>
            </DialogActions>
          </Dialog>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={modalStyle}>
              <Formik
                initialValues={{ name:null, email: null, role: value, password: null }}
                validate={values => {
                  const errors = {};
                  if (!values.email) {
                    errors.email = 'Required';
                  } else if (
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                  ) {
                    errors.email = 'Email tidak valid';
                  }

                  if (values.password !== values.passwordConfirm) {
                    errors.passwordConfirm = 'Konfirmasi password harus sama';
                  }
                  return errors;
                }}
                onSubmit={async (values, { setSubmitting }) => {
                  if(tabIndex.agen === values.role) values.role = 'agen';
                  if(tabIndex.reseller === values.role) values.role = 'reseller';
                  if(tabIndex.marketer === values.role) values.role = 'marketer';

                  values.wa = wa !== null ? wa : null;
                  values.provinsi = valueProvince !== null ? valueProvince.province_id : null;
                  values.kota = valueCity !== null ? valueCity.city_id : null;
                  values.kecamatan = valueSubdistrict !== null ? valueSubdistrict.subdistrict_id : null;

                  const filteredVal = Object.keys(values).reduce((newObj, key) => {
                    const value = values[key];
                    if (value !== null) {
                        newObj[key] = value;
                    }
                    return newObj;
                  }, {});

                  try {

                    await axios.post(`${process.env.REACT_APP_API_URL}/api/dashboard/subdb/add`, filteredVal, {
                      headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                      }
                    });
                    // update states
                    const agen = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/subdb/list`, {
                      headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                      }
                    });
          
                    let mappedObj = {};
                    let tabIndexObj = {};
                    let index = -1;
          
                    Object.keys(agen.data.result).forEach((v,i) => {
                      index+=1;
                      let number = 0;
                      mappedObj[v] = agen.data.result[v].map((item) => {
                        number+=1;
                        return { ...item, no: number };    
                      })
                      tabIndexObj[v] = index;
                    });
                    setData(mappedObj);
                    setTabIndex(tabIndexObj);
                    
                    setAlertStatus('success');
                    setAlertMessage('Submit berhasil')
                    setOpenAlert(true);
                    handleClose();
                  } catch (err) {
                    console.log(err);
                    setSubmitting(false);
                  }
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  /* and other goodies */
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sx={{ textAlign: 'center' }}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                          TAMBAH MITRA
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          id="outlined-basic"
                          label="Nama mitra"
                          variant="outlined"
                          name="name"
                        />
                        <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                          {errors.name && touched.name && errors.name}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          id="outlined-basic"
                          label="Email"
                          variant="outlined"
                          name="email"
                        />
                        <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                          {errors.email && touched.email && errors.email}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <InputLabel id="demo-simple-select-label">Status Kemitraan</InputLabel>
                        <Select
                          fullWidth
                          disabled
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={value}
                          onChange={handleChange}
                          name="role"
                        >
                          <MenuItem value={tabIndex.agen}>Agen</MenuItem>
                          <MenuItem value={tabIndex.reseller}>Reseller</MenuItem>
                          <MenuItem value={tabIndex.marketer}>Marketer</MenuItem>
                        </Select>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          type="password"
                          id="outlined-basic"
                          label="Password"
                          variant="outlined"
                          name="password"
                        />
                        <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                          {errors.password && touched.password && errors.password}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          type="password"
                          id="outlined-basic"
                          label="Konfirmasi Password"
                          variant="outlined"
                          name="passwordConfirm"
                        />
                        <Typography id="modal-modal-title" color="red" variant="subtitle2" component="span" sx={{ padding: '5px'}}>
                          {errors.passwordConfirm && touched.passwordConfirm && errors.passwordConfirm}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                            No Whatsapp
                        </InputLabel>
                        <PhoneInput
                            disableDropdown
                            countryCodeEditable={false}
                            name="noWa"
                            country={'id'}
                            onlyCountries={['id']}
                            value={wa}
                            inputStyle={{ width: '100%', height: '3em' }}
                            onChange={changeWa}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                          <TextField
                            fullWidth
                            label="Alamat"
                            name="alamat"
                            id="outlined-multiline-static"
                            multiline
                            rows={4}
                            onChange={handleChange}
                          />
                      </Grid>
                      <Grid item xs={12} md={6}>
                          <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                              Provinsi Tujuan
                          </InputLabel>
                          <Autocomplete
                              fullWidth
                              size="small"
                              value={valueProvince}
                              onChange={handleSelectProvince}
                              options={provinces}
                              getOptionLabel={(option) => option.province_name}
                              renderOption={(props, option) => (
                                  <li {...props}>
                                      {option.province_name}
                                  </li>
                              )}
                              renderInput={(params) => <TextField {...params} />}
                          />
                      </Grid>
                      <Grid item xs={12} md={6}>                            
                          <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                              Kota/Kabupaten Tujuan
                          </InputLabel>
                          <Autocomplete
                              fullWidth
                              disabled={cities.length === 0}
                              size="small"
                              value={valueCity}
                              onChange={handleSelectCity}
                              options={cities}
                              getOptionLabel={(option) => option.city_name}
                              renderOption={(props, option) => (
                                  <li {...props}>
                                      {option.city_name}
                                  </li>
                              )}
                              renderInput={(params) => <TextField {...params} />}
                          />
                      </Grid>
                      <Grid item xs={12} md={6}>
                          <InputLabel sx={{ whiteSpace: 'normal', minHeight: '22px', fontSize: '14px' }}>
                              Kecamatan Tujuan
                          </InputLabel>
                          <Autocomplete
                              fullWidth
                              disabled={subdistricts.length === 0}
                              size="small"
                              value={valueSubdistrict}
                              onChange={handleSelectSubdistrict}
                              options={subdistricts}
                              getOptionLabel={(option) => option.subdistrict_name}
                              renderOption={(props, option) => (
                                  <li {...props}>
                                      {option.subdistrict_name}
                                  </li>
                              )}
                              renderInput={(params) => <TextField {...params} />}
                          />
                      </Grid>
                      <Grid item xs={12} md={6}>
                          <TextField
                              fullWidth
                              label="Kode Pos"
                              type="number"
                              size="small"
                              name="kodePos"
                              id="outlined-basic"
                              variant="outlined"
                              onChange={handleChange}
                          />
                      </Grid>
                      <Grid item xs={12} sx={{ textAlign: 'right', padding: '10px 0px' }}>
                        <Button variant="contained" type="submit" disabled={isSubmitting}>Submit</Button>
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            </Box>
          </Modal>
            <Grid container spacing={2}>
              <Grid item xs={12} sx={{ margin: '10px 14px'}}>
                  <Typography variant="h5" fontWeight="700">Sub Distributor</Typography>
              </Grid>
            </Grid>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                {data.agen && (<Tab label="Agen" {...a11yProps(0)} />)}
                {data.reseller && (<Tab label="Reseller" {...a11yProps(1)} />)}
                {data.marketer && (<Tab label="Marketer" {...a11yProps(2)} />)}
              </Tabs>
            </Box>
            {data.agen && (
              <TabPanel value={value} index={tabIndex.agen}>
                <Stack direction="row" spacing={2} sx={{ py: '20px' }}>
                  <Button variant="contained" startIcon={<AddCircleIcon />} onClick={handleOpen}>
                    Add
                  </Button>
                </Stack>
                <TableContainer component={Paper} sx={{ maxHeight: {xs: '66vh', sm: 640, md: 768} }}>
                  <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell>No</TableCell>
                        <TableCell>Nama Agen</TableCell>
                        <TableCell align="left">Email</TableCell>
                        <TableCell align="left">Whatsapp</TableCell>
                        <TableCell align="left">Telegram</TableCell>
                        <TableCell align="left">Facebook</TableCell>
                        <TableCell align="left">Alamat</TableCell>
                        <TableCell align="left">Aksi</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.agen.map((row) => (
                        <TableRow
                          key={row.idmitraagen}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell align="left">{row.no}</TableCell>
                          <TableCell component="th" scope="row">
                            {row.namaagen}
                          </TableCell>
                          <TableCell align="left">{row.email}</TableCell>
                          <TableCell align="right">{row.whatsapp}</TableCell>
                          <TableCell align="left">{row.telegram}</TableCell>
                          <TableCell align="left">{row.facebook}</TableCell>
                          <TableCell align="left">{row.alamat}</TableCell>
                          <TableCell align="left">
                            <Button><DeleteIcon onClick={() => handleDeleteDialog(row.idmitraagen, 'agen')} /></Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </TabPanel>
            )}
            {data.reseller && (
              <TabPanel value={value} index={tabIndex.reseller}>
                <Stack direction="row" spacing={2} sx={{ py: '20px' }}>
                  <Button variant="contained" startIcon={<AddCircleIcon />} onClick={handleOpen}>
                    Add
                  </Button>
                </Stack>
                <TableContainer component={Paper} sx={{ maxHeight: {xs: 440, sm: 640, md: 768} }}>
                  <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell>No</TableCell>
                        <TableCell>Nama Reseller</TableCell>
                        <TableCell align="right">Email</TableCell>
                        <TableCell align="right">Whatsapp</TableCell>
                        <TableCell align="right">Telegram</TableCell>
                        <TableCell align="right">Facebook</TableCell>
                        <TableCell align="left">Alamat</TableCell>
                        <TableCell align="left">Aksi</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.reseller.map((row) => (
                        <TableRow
                          key={row.idmitrareseller}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell align="left">{row.no}</TableCell>
                          <TableCell component="th" scope="row">
                            {row.namaagen}
                          </TableCell>
                          <TableCell align="left">{row.email}</TableCell>
                          <TableCell align="left">{row.whatsapp}</TableCell>
                          <TableCell align="left">{row.telegram}</TableCell>
                          <TableCell align="left">{row.facebook}</TableCell>
                          <TableCell align="left">{row.alamat}</TableCell>
                          <TableCell align="left">
                            <Button><DeleteIcon onClick={() => handleDeleteDialog(row.idmitrareseller, 'reseller')} /></Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </TabPanel>
            )}
            {data.marketer && (
              <TabPanel value={value} index={tabIndex.marketer}>
                <Stack direction="row" spacing={2} sx={{ py: '20px' }}>
                  <Button variant="contained" startIcon={<AddCircleIcon />} onClick={handleOpen}>
                    Add
                  </Button>
                </Stack>
                <TableContainer component={Paper} sx={{ maxHeight: {xs: 440, sm: 640, md: 768} }}>
                  <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell>No</TableCell>
                        <TableCell>Nama Marketer</TableCell>
                        <TableCell align="left">Email</TableCell>
                        <TableCell align="left">Whatsapp</TableCell>
                        <TableCell align="left">Telegram</TableCell>
                        <TableCell align="left">Facebook</TableCell>
                        <TableCell align="left">Alamat</TableCell>
                        <TableCell align="left">Aksi</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.marketer.map((row) => (
                        <TableRow
                          key={row.idmitramarketer}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell align="left">{row.no}</TableCell>
                          <TableCell component="th" scope="row">
                            {row.namaagen}
                          </TableCell>
                          <TableCell align="left">{row.email}</TableCell>
                          <TableCell align="right">{row.whatsapp}</TableCell>
                          <TableCell align="left">{row.telegram}</TableCell>
                          <TableCell align="left">{row.facebook}</TableCell>
                          <TableCell align="left">{row.alamat}</TableCell>
                          <TableCell align="left">
                            <Button><DeleteIcon onClick={() => handleDeleteDialog(row.idmitramarketer, 'marketer')} /></Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </TabPanel>
            )}
        </div>
    )
}

export default Subdb;
